module.exports = __webpack_public_path__ + "static/media/apply-eth-mobile.ac0455a1.png";